<template>
<div>
  <div class="form__bg">
    <section class="section">
      <div class="form__inputs">
          <AppInput
            title="Название роли пользователя"
            :value="role.name"
            :valid="validation.name"
            required
            @value-changed="setRoleName"
            @got-focus="clearValidation('name')"
            :disabled="!roleAccessEdit"
          />
      </div>
      <AppSwitch title="Роль замерщика, установщика или мастера"
                name="role"
                @toggleCheck="setToggleStatuses"
                :onCheck="role.is_Statuses ? true : false"
                :disabled="!roleAccessEdit"
      />
      <AppSwitch title="Роль юриста"
                name="lawyer"
                @toggleCheck="setToggleLawyer"
                :onCheck="role.is_lawyer ? true : false"
                :disabled="!roleAccessEdit"
      />
      <AppSwitch title="Полные права"
                name="role"
                @toggleCheck="setToggleAdmin"
                :onCheck="role.is_admin ? true : false"
                :disabled="!roleAccessEdit"
      />
      <div class="page__row" style="column-gap:20px; margin-top: 32px">
        <AppButtonSmAdd
          v-if="$router.history.current.params.id !== 'create'"
          @click.native="openRoleStatusModal('create')"
          type="create"
          title="Создание Статуса"
        />
      </div>
    </section>
  </div>

  <div class="page__row">
    <div class="section page__content">
      <div class="table__buttons" style="margin-bottom: 32px">
        <h2 class="subtitle" style="margin-right: auto; margin-bottom: 0;">Статусы</h2>
        <transition name="fade" >
          <AppButtonSmRemove
            style="margin-right: 20px"
            v-if="selectedStatusesIsActiveDelete"
            title="Удалить"
            @click.stop.native="showRemoveConfirmationGroupStatuses"
          />
        </transition>
        <AppButtonSmAdd
          title="Добавить"
          @click.stop.native="showStatusesModal"
        />
      </div>
      <transition name="fade">
          <PvhRoleStatusesModal
            v-show="statusesModal.active"
            :isLoading = statusesModal.isLoading
            @close-modal="closeStatusesModal"
          >
            <template v-slot:statusesModalBody>
              <AppTable
                v-if="!statusesModal.isLoading"
                isSpecial
                :data="statusesVal"
                :state="statusesModal"
                :headers="statusesTableHeaders.headers"
                :all-items-active="statusesTableHeaders.allActive"
                :has-checkbox=true
                :isMenuControlsActive=false
                @toggle-active-item="toggleStatusesListActiveItem"
                @toggle-active-all="toggleStatusesListActiveAll"
              />
            </template>

            <template v-slot:statusesModalFooter>
              <div class="page__row" v-if="statusesPagination.lastPage > 1">
                <VPagination
                  :pageList="statusesPagination.pageList"
                  :currentPage="statusesPagination.currentPage"
                  @get-page="getStatusesPage"
                />
              </div>
              <div class="modal__button-wrap">
                <div class="modal__button">
                  <AppButton
                    title="Добавить"
                    type="main"
                    @click.native="addSelectedStatuses"
                  />
                </div>
                <div class="modal__button">
                  <AppButton
                    title="Отмена"
                    type="alt"
                    @click.native="closeStatusesModal"
                  />
                </div>
              </div>
            </template>
          </PvhRoleStatusesModal>
        </transition>

        <AppTable
          v-if="statusesSelected.length !== 0"
          isSpecial
          :data="statusesSelected"
          :headers="statusesSelectedTableHeaders.headers"
          :has-checkbox="roleAccessEdit"
          :isMenuControlsActive=false
          :all-items-active="statusesSelectedTableHeaders.allActive"
          @toggle-active-item="toggleSelectedStatusesListActiveItem"
          @toggle-active-all="toggleSelectedStatusesListActiveAll"
        />
      <div class="page__row"  v-else>
        <div class="no-records page__no-records">
          <AppNoRecordsPlaceholder
            text="Записи не найдены"
          />
        </div>
      </div>
      <transition name="fade" v-if="roleAccessEdit">
        <AppConfirmation
          v-if="removeConfirmationSelectedStatuses.active"
          text="Вы действительно хотите убрать эти статусы?"
          @confirm="deleteSelectedStatusesChecked()"
          @reject="closeModalRemoveSelectedStatuses"
        />

        <AppModal
          v-if="deleteSelectedStatusesResponseModal.isActive"
          :title="deleteSelectedStatusesResponseModal.title"
          :text="deleteSelectedStatusesResponseModal.text"
          confirmButtonTitle="Ок"
          :confirmButtonType="deleteSelectedStatusesResponseModal.type"
          @confirm="closeStatusesSelectedDeleteModal"
        />
      </transition>
    </div>
  </div>

  <PvhRoleStatusModal
    v-if="roleStatusModal"
    @close="roleStatusModal = false"
    :modalType="typeModal"
    :role="role"
  />
</div>
</template>

<script>
import AppInput from '@/components/page/input/AppInput'
import AppSwitch from '@/components/page/input/AppSwitch'
import AppTable from '@/components/page/table/AppTable'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import PvhRoleStatusModal from '@/components/page/modal/PvhRoleStatusModal.vue'
import AppButton from '@/components/page/button/AppButton'
import PvhRoleStatusesModal from '@/components/pvh/PvhRoleStatusesModal'
import VPagination from '@/components/page/VPagination'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppModal from '@/components/page/modal/AppModal'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'

export default {
  components: {
    AppSwitch,
    AppButtonSmAdd,
    AppButtonSmRemove,
    AppInput,
    AppTable,
    PvhRoleStatusModal,
    PvhRoleStatusesModal,
    AppButton,
    VPagination,
    AppConfirmation,
    AppModal,
    AppNoRecordsPlaceholder
  },
  name: 'PvhRoleMainUpdateInfo',
  data () {
    return {
      isCreate: false,
      isActiveDelete: false,
      removeConfirmationSelectedStatuses: {
        active: false,
        id: null,
        group: false
      },
      statusTableHeader: {
        allActive: false,
        headers: [
          {
            title: 'Название',
            isSortable: true
          },
          {
            title: 'Цвет',
            isSortable: true
          },
          {
            title: 'Ручной выбор',
            isSortable: true
          }
        ]
      },
      statuses: [],
      roleStatusModal: false,
      typeModal: 'create'
    }
  },
  computed: {
    tableHeaders () {
      return this.$store.getters['[pvh] getRoleTableHeaders']
    },
    role () {
      return this.$store.getters['[pvh] getRoleForUpdate']
    },

    statusesModal () {
      return this.$store.getters['[pvh] getRoleStatusesListModal']
    },
    statusesTableHeaders () {
      return this.$store.getters['[pvh] getRoleStatusesTableHeaders']
    },
    statusesSelectedTableHeaders () {
      return this.$store.getters['[pvh] getRoleStatusesSelectedTableHeaders']
    },
    statusesVal () {
      return this.$store.getters['[pvh] getRoleUpdateStatusesList']
    },
    selectedStatusesIsActiveDelete () {
      return this.$store.getters['[pvh] getRoleStatusesSelectedIsActiveDelete']
    },
    statusesSelected () {
      return this.$store.getters['[pvh] getRoleUpdateStatusesSelected']
    },
    deleteSelectedStatusesResponseModal () {
      return this.$store.getters['[pvh] getRoleStatusesSelectedResponseModal']
    },
    statusesPagination () {
      return this.$store.getters['[pvh] getRoleUpdateStatusesPagination']
    },

    validation () {
      return this.$store.getters['[pvh] getRoleUpdateValidation']
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isLoading () {
      return this.$store.getters['[pvh] getRoleUpdateIsLoading']
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightPvh.actions.update
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightPvh.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightPvh.actions.remove
    }
  },
  methods: {
    saveRoleInfo () {
      const id = this.$router.history.current.params.id
      this.$store.dispatch('[pvh] roleUpdateSaveInfo', id)
    },
    setRoleName (value) {
      this.$store.dispatch('[pvh] roleUpdateSetName', value)
    },
    // TODO CHECK WORK
    setToggleStatuses () {
      this.$store.dispatch('[pvh] roleUpdateSetStatuses')
    },
    setToggleLawyer () {
      this.$store.dispatch('[pvh] roleUpdateSetLawyer')
    },
    setToggleAdmin () {
      this.$store.dispatch('[pvh] roleUpdateSetAdmin')
    },
    // TODO CHECK WORK
    setRoleInformer (informer) {
      this.$store.dispatch('[pvh] roleUpdateSetInformer', informer)
    },

    clearValidation (inputName) {
      this.$store.dispatch('[pvh] roleUpdateClearValidation', inputName)
    },
    leavePage () {
      this.$router.push({ name: 'PvhRoleList' })
    },

    showStatusesModal () {
      this.$store.dispatch('[pvh] showRoleStatusesListModal')
    },
    closeStatusesModal () {
      this.$store.dispatch('[pvh] closeRoleStatusesListModal')
    },
    addSelectedStatuses () {
      this.$store.dispatch('[pvh] addRoleStatusesSelected')
    },
    toggleStatusesListActiveItem (itemId) {
      this.$store.dispatch('[pvh] toggleRoleStatusesListItemActive', itemId)
    },
    toggleStatusesListActiveAll () {
      this.$store.dispatch('[pvh] toggleRoleStatusesListItemActiveAll')
    },
    toggleSelectedStatusesListActiveItem (itemId) {
      this.$store.dispatch('[pvh] toggleRoleSelectedStatusesListItemActive', itemId)
    },
    toggleSelectedStatusesListActiveAll () {
      this.$store.dispatch('[pvh] toggleRoleSelectedStatusesListItemActiveAll')
    },
    closeModalRemoveSelectedStatuses () {
      this.removeConfirmationSelectedStatuses.active = false
      this.removeConfirmationSelectedStatuses.id = null
      this.removeConfirmationSelectedStatuses.group = false
    },
    showRemoveConfirmationGroupStatuses () {
      this.removeConfirmationSelectedStatuses.active = true
      this.removeConfirmationSelectedStatuses.id = null
      this.removeConfirmationSelectedStatuses.group = true
    },
    deleteSelectedStatusesChecked () {
      this.removeConfirmationSelectedStatuses.active = false
      this.$store.dispatch('[pvh] deleteRoleStatusesSelectedCheckedItems')
      this.removeConfirmationSelectedStatuses.group = false
    },
    closeStatusesSelectedDeleteModal () {
      this.$store.dispatch('[pvh] closeRoleStatusesSelectedDeleteModal')
    },

    // pagination
    getStatusesPage (pageNum) {
      this.$store.dispatch('[pvh] getRoleStatusesListPage', pageNum)
    },

    openRoleStatusModal (typeModal) {
      this.typeModal = typeModal
      this.roleStatusModal = true
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>

</style>
